import { Pipe, PipeTransform } from '@angular/core';
import { FileRecordDto } from '@careapp-group/ng-sdk';

/**
 * Given a FileRecordDto - return either the record itself (for images)
 * or the thumbnail record (in the case of videos).
 *
 * Should be piped to `filedownloadurl` in order to render.
 */
@Pipe({
  name: 'mediaVariant',
  pure: true,
  standalone: false,
})
export class MediaVariantPipe implements PipeTransform {
  transform(
    value: FileRecordDto,
    variantProperty: 'purpose' | 'mimeType',
    variantType: string,
    fallbackToOriginal: boolean = false,
  ) {
    if (!value) {
      return;
    }

    const typeRegExp = new RegExp(variantType);
    if (value[variantProperty] && typeRegExp.test(value[variantProperty])) {
      return value;
    }

    const variant = (value.variants || []).find((item) => typeRegExp.test(item[variantProperty]));

    if (!variant && fallbackToOriginal) {
      return value;
    }

    return variant;
  }
}
